import { useCallback, useEffect, useState } from 'react'
import { ErrorApi } from '../api/cliente'

export function mensajeDeError(fallo: unknown): string {
    return fallo instanceof ErrorApi
        ? fallo.mensajeVisible()
        : 'No se pudo conectar con el servidor.'
}

interface Estado<T> {
    datos: T | null
    cargando: boolean
    error: string | null
    recargar: () => void
    fijar: (datos: T) => void
}

/**
 * Carga datos de la API y expone los tres estados que toda pantalla necesita.
 *
 * Evita repetir el mismo bloque de try/catch/finally en cada pantalla, y sobre
 * todo evita olvidar el caso de error, que es el que se nota en la tienda.
 */
export function usarCargar<T>(obtener: () => Promise<T>, dependencias: unknown[] = []): Estado<T> {
    const [datos, setDatos] = useState<T | null>(null)
    const [cargando, setCargando] = useState(true)
    const [error, setError] = useState<string | null>(null)
    const [version, setVersion] = useState(0)

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const cargar = useCallback(obtener, dependencias)

    useEffect(() => {
        let vigente = true

        setCargando(true)
        setError(null)

        cargar()
            .then((resultado) => {
                if (vigente) setDatos(resultado)
            })
            .catch((fallo) => {
                if (vigente) setError(mensajeDeError(fallo))
            })
            .finally(() => {
                if (vigente) setCargando(false)
            })

        return () => {
            vigente = false
        }
    }, [cargar, version])

    return {
        datos,
        cargando,
        error,
        recargar: () => setVersion((v) => v + 1),
        fijar: setDatos,
    }
}
